/* External dependencies */
import React from 'react';
import { createStyled } from 'styletron-react';
import { driver, getInitialStyle } from 'styletron-standard';

/* Local dependencies */
import { theme } from './constants/theme';
import { StyledProps, Theme, WithThemeProps } from './types';

export const ThemeContext = React.createContext<Theme>(theme);
const { Consumer: ThemeConsumer } = ThemeContext;

const wrapper = <P extends WithThemeProps>(StyledComponent: React.ComponentType<P & StyledProps>) =>
  function withThemeHOC(props: P) {
    return <ThemeConsumer>{(theme) => <StyledComponent {...props} $theme={theme} />}</ThemeConsumer>;
  };

export const styled = createStyled({
  wrapper,
  getInitialStyle,
  driver,
});
